export const prefixTranslation = 'home.lmsIndex'
